module.exports = __webpack_public_path__ + "img/welcome_19.844ace34.jpg";